import { render, staticRenderFns } from "./PersonalProtectiveEquipmentCreateOrUpdate.vue?vue&type=template&id=71112f02&"
import script from "./PersonalProtectiveEquipmentCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./PersonalProtectiveEquipmentCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports